import { Routes } from '@angular/router';
import { authGuard } from '@core/auth/auth.guard';
import { permissionChildGuard } from '@core/auth/permission.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('@features/auth/login/login.component').then((m) => m.LoginComponent)
  },
  {
    path: 'recuperar-password',
    loadComponent: () =>
      import('@features/auth/recover-password/recover-password.component').then(
        (m) => m.RecoverPasswordComponent
      )
  },
  {
    path: 'restablecer-password',
    loadComponent: () =>
      import('@features/auth/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent
      )
  },
  {
    path: 'activar-cuenta',
    loadComponent: () =>
      import('@features/auth/activate-account/activate-account.component').then(
        (m) => m.ActivateAccountComponent
      )
  },
  {
    path: 'boot',
    canActivate: [authGuard],
    loadComponent: () => import('@features/auth/boot/boot.component').then((m) => m.BootComponent)
  },
  {
    path: 'app',
    canActivate: [authGuard],
    canActivateChild: [permissionChildGuard],
    loadComponent: () =>
      import('@core/layout/admin-layout/admin-layout.component').then((m) => m.AdminLayoutComponent),
    loadChildren: () => import('@features/admin/admin.routes').then((m) => m.ADMIN_ROUTES)
  },
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  { path: '**', redirectTo: 'login' }
];
